module.exports = __webpack_public_path__ + "img/bin.94c293e7.png";